import Button from "@mui/material/Button";
import { FC, PropsWithChildren } from "react";

const OauthHeader: FC<PropsWithChildren<{ onClick: () => unknown }>> = ({ children, onClick }) => (
  <Button
    fullWidth
    variant="contained"
    onClick={onClick}
    sx={{ mt: 3, mb: 2 }}
  >
    {children}
  </Button>
);

export default OauthHeader;
